// pre-defined imports
import { useState } from 'react';
import { Button, Box } from '@mui/material';

import { PrivacyPolicyModal } from './PrivacyPolicyModal';

// style imports
import styles from './Footer.module.scss';

export const Footer = () => {
  const [openPrivacyPol, setOpenPrivacyPol] = useState(false);
  const onPolicyBtnClicked = () => setOpenPrivacyPol(true);

  return (
    <>
      <footer>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            minHeight: 68
          }}
        >
          <Button onClick={onPolicyBtnClicked} disableRipple className={styles.privacyPolicyBtn}>Privacy Policy
          </Button>
          <Box
            component="div"
            className={styles.footerImgWrap}
          >
            <Box
              component="img"
              src="./assets/images/Footer_Logo.svg"
              alt="E-Reg Logo"
              className={styles.footerRoundLogo}
              sx={{
                width: 45,
              }}
            />
          </Box>
        </Box>
      </footer >
      <PrivacyPolicyModal openPrivacyPol={openPrivacyPol} setOpenPrivacyPol={setOpenPrivacyPol} />
    </>
  );
};
